// extracted by mini-css-extract-plugin
export default {"Title":"Advanced_Title__cjzg7","SwitchGeneralContainer":"Advanced_SwitchGeneralContainer__FoYO-","TextContainer":"Advanced_TextContainer__W+zUv"};